import { Injectable } from '@angular/core';
import { DatabaseService } from '../alcance/services/database.service';
import { DatabaseRelation } from '../alcance/interfaces/database';

@Injectable({
  providedIn: 'root'
})
export class BrigadistaDBService extends DatabaseService{
    override classname: string = 'BrigadistaDBService';
    override keyPath = 'usuario_id';
    override table = 'brigadista';

    protected override migration: number = 1;

    override indices = [
        {name: "by_id", field: "usuario_id", unique: false, multiEntry: false},
        {name: "by_edificacao", field: "edificacao_id", unique: false, multiEntry: false},
        {name: "by_andar", field: "andar_id", unique: false, multiEntry: false},
        {name: "by_turno", field: "turno_id", unique: false, multiEntry: false},
        {name: "by_sinc", field: "sinc", unique: false, multiEntry: false}
    ];

    protected override relations: DatabaseRelation[] = [
        {name: 'usuario', table: 'usuario', field: 'usuario_id', type: 'foreign'},
    ];

    protected override collectObj(obj: any) {
        obj.edificacao_id = obj.edificacao_id || obj.andar?.edificacao_id || obj.turno?.edificacao_id;
        return super.collectObj(obj);
    }
}

